import { generateTranslations } from '../i18n/translation';

const namespace = 'dashboard';

const translations = generateTranslations(namespace, {
  title: { nb: 'Dashbord', en: 'Dashboard' },
  welcome: {
    nb: 'Hei {name} og velkommen til  Arbeidslivsportalen',
    en: 'Hi {name} and welcome to Arbeidslivsportalen',
  },
  linkToCalendar: {
    nb: 'Gå til praksiskalenderen',
    en: 'Go to practice calendar',
  },
  desc: {
    nb: 'Her finner du informasjon som er relevant for deg. Til venstre ser du hovedmenyen din. I praksiskalenderen din vil du finne alle praksisaktiviteter som du kan opprette og vedlikeholde.',
    en: "Here you'll find a summary of relevant information. On your left you have your main menu. In the practice calendar you'll find all practice activities that you can create and maintain.",
  },
  orders: {
    nb: 'Bestillinger',
    en: 'Orders',
  },
  institusjonHeader: {
    nb: 'Institusjon',
    en: 'Institution',
  },
  periodeHeader: {
    nb: 'Periode',
    en: 'Duration',
  },
  praksistypeHeader: {
    nb: 'Praksistype',
    en: 'Practice type',
  },
  aktivitetskravHeader: {
    nb: 'Aktivitetskrav',
    en: 'Activity requirements',
  },
  handlingHeader: {
    nb: 'Handling',
    en: 'Action',
  },
  handlingBtn: {
    nb: 'Til bestillingen',
    en: 'See the order',
  },
  aktiv: {
    nb: 'Aktive bestillinger:',
    en: 'Active orders:',
  },
  kommende: {
    nb: 'Kommende bestillinger:',
    en: 'Upcoming orders:',
  },
  gjennomfoert: {
    nb: 'Gjennomførte bestillinger (fra det siste halvåret):',
    en: 'Completed orders (from the past six months):',
  },
  statusFsSyncTitle: {
    nb: 'Synkronisering med FS',
    en: 'Synchronization with FS',
  },
  statusFsSyncSubtitle: {
    nb: 'Gjeldende synkroniseringsstatus for data tilknyttet din institusjon i FS.',
    en: 'The current sync status for data associated with your institution in FS.',
  },
  syncTypeInstitusjon: { nb: 'Institusjon', en: 'Institution' },
  syncTypeEmne: { nb: 'Emne', en: 'Subject' },
  syncTypePraksisavtale: { nb: 'Praksisavtale', en: 'Practice agreement' },
  syncTypePraksissted: { nb: 'Praksissted', en: 'Practice place' },
  syncTypePraksistype: { nb: 'Praksistype', en: 'Practice type' },
  syncTypeStudent: { nb: 'Student', en: 'Student' },
  syncTypeStudiested: { nb: 'Studiested', en: 'Institution (lower level)' },
  syncTypeUndervisningsenhet: {
    nb: 'Undervisningsenhet',
    en: 'Undervisningsenhet',
  },
  syncStatusOk: {
    nb: 'Ingen feil',
    en: 'No errors',
  },
  syncStatusFeiletSisteDogn: {
    nb: 'Feilet (< 24 timer)',
    en: 'Unsuccessful (< 24 hours)',
  },
  syncStatusFeilet: {
    nb: 'Feilet',
    en: 'Unsuccessful',
  },
  syncStatusUkjent: {
    nb: 'Ukjent tilstand',
    en: 'Unknown state',
  },
  headerType: {
    nb: 'Type',
    en: 'Type',
  },
  headerStatus: {
    nb: 'Status',
    en: 'Status',
  },
  headerNesteKjoring: {
    nb: 'Neste synkronisering',
    en: 'Next synchronization',
  },
  headerSisteVellykket: {
    nb: 'Siste vellykede synkronisering',
    en: 'Last successful synchronization',
  },
  headerFeilmelding: {
    nb: 'Feilmelding',
    en: 'Error message',
  },
  headerFjern: {
    nb: 'Fjern feil (NB: gjelder for alle brukere)',
    en: 'Remove error (IMPORTANT: applies to all users)',
  },
  feilmeldingerFsTitle: {
    nb: 'Feilmeldinger fra FS',
    en: 'Error messages from FS',
  },
  feilmeldingerFsSubtitle: {
    nb: 'Under vises alle feilmeldinger fra FS som er tilknyttet din institusjon, men som ikke er tilknyttet praksisaktiviteter. Eventuelle feilmeldinger knyttet til publisering av praksisaktiviteter vises i fordelingsfanen til rammede praksisaktiviteter.',
    en: 'Error messages from FS that are associated with your institution, but not with given practice activities are shown below. Error messages that are connected to the publishing of practice activities are shown in the assignment tab of affected practice activities.',
  },
  clearForAllUsers: {
    nb: 'Markér feilen som ordnet',
    en: 'Mark error as solved',
  },
  clearSuccess: {
    nb: 'Feilmeldingen ble markert som ordnet.',
    en: 'The error was marked solved.',
  },
});

export default translations;
